import React, { useEffect, useState } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import About from '../pages/About';
import Assignments from '../pages/Assignments';
import Contact from '../pages/Contact';
import Home from '../pages/Home';
import Jurisdictions from '../pages/Jurisdictions';
import NotFound from '../pages/NotFound';
import ReportIncident from '../pages/ReportIncident';
import i18next from 'i18next';
import { SmsLanding } from '../components/ReportIncident/UpdatesPage';
import News from '../pages/News';
import Privacy from '../pages/Privacy';
import Terms from '../pages/Terms';

const RouteHandler = () => {
  const [language, setLanguage] = useState('')
  useEffect(() => {
    const lang = localStorage.getItem('lang')
    setLanguage(lang)
  }, [localStorage.getItem('lang')])

  return (
    // console.log(language,"language"),
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/en" />} />
        <Route path="/en" element={<Home />} />
        <Route path="/ar" element={<Home />} />

        <Route path="/en/about" element={<About />} />
        <Route path="/ar/about" element={<About />} />

        <Route path="/en/contact" element={<Contact />} />
        <Route path="/ar/contact" element={<Contact />} />

        <Route path="/en/news" element={<News.Listing />} />
        <Route path="/ar/news" element={<News.Listing />} />

        <Route path="/en/news/:id" element={<News.Details />} />
        <Route path="/ar/news/:id" element={<News.Details />} />

        <Route path="/en/assignments/:page?" element={<Assignments />} />
        <Route path="/ar/assignments/:page?" element={<Assignments />} />

        <Route path="/en/jurisdictions/:page?" element={<Jurisdictions />} />
        <Route path="/ar/jurisdictions/:page?" element={<Jurisdictions />} />

        <Route path="/en/report_incident/:page?" element={<ReportIncident page={'firstPage'} />} />
        <Route path="/ar/report_incident/:page?" element={<ReportIncident page={'firstPage'} />} />

        <Route path="/incident_update/:id" element={<SmsLanding />} />

        <Route path="/en/incident_update/:id" element={<ReportIncident page={'update'} />} />
        <Route path="/ar/incident_update/:id" element={<ReportIncident page={'update'} />} />

        <Route path="/en/privacy" element={<Privacy />} />
        <Route path="/ar/privacy" element={<Privacy />} />

        <Route path="/en/terms" element={<Terms />} />
        <Route path="/ar/terms" element={<Terms />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </>

  );
}

export default RouteHandler;
